import { render, staticRenderFns } from "./GoBackHeader.vue?vue&type=template&id=704cbc4f&scoped=true"
import script from "./GoBackHeader.vue?vue&type=script&lang=ts"
export * from "./GoBackHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704cbc4f",
  null
  
)

export default component.exports